import { Severity } from '../../shared/enums/severity';
import { ApiMessage } from './api-message';

export class ApiResult {
  success: boolean;
  severity: Severity;
  messages: ApiMessage[] = [];

  public loadFromJson(data) {
    if (data.success !== undefined && data.messages !== undefined) {
      this.success = data.success;
      this.severity = data.severity;
      this.messages = new Array<ApiMessage>();
      for (const input of data.messages) {
        const message = new ApiMessage();
        message.loadFromJson(input);
        this.messages.push(message);
      }
    } else {
      throw Error('Unexpected parameter value');
    }
  }
}
